import { useTranslation } from 'react-i18next';
import { OrderPriceType } from '@global/utils/orderUtils';
import './style.scss';
import { subscriptionFrequencySelector } from '@src/global/store/slices/cart/selectors';
import { useAppSelector } from '@src/global/store/hooks';

interface BillingInfoProps {
  nextBillDate: string;
  orderPrice: OrderPriceType;
}

export const BillingInfo = ({ nextBillDate, orderPrice }: BillingInfoProps) => {
  const { t } = useTranslation();

  const subscriptionFrequency = useAppSelector(subscriptionFrequencySelector);
  const frequency =
    t(`subscription.${subscriptionFrequency}.capitalizedFrequency`) || '';

  return (
    <div className="confirmation-billing">
      <div>
        <p className="confirmation-billing__column-header">
          {t('confirmation.subscription.nextBill')}
        </p>
        <p className="confirmation-billing__column-value">{nextBillDate}</p>
      </div>
      <div>
        <p className="confirmation-billing__column-header">
          {t('confirmation.subscription.recurringBill', { frequency })}
        </p>
        <p className="confirmation-billing__column-value">
          {orderPrice.total?.code}
          {orderPrice.total?.value?.toFixed(2)}
        </p>
      </div>
    </div>
  );
};
